import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/complaints/load',
    method: 'get',
    params
  })
}


export function del(data) {
  return request({
    url: '/complaints/delete',
    method: 'post',
    data
  })
}

export function receive(data) {
  return request({
    url: '/complaints/receive',
    method: 'post',
    data
  })
}

export function close(data) {
  return request({
    url: '/complaints/close',
    method: 'post',
    data
  })
}

export function restore(data) {
  return request({
    url: '/complaints/restore',
    method: 'post',
    data
  })
}

export function getAuditLogs(id){
  return request({
    url: '/complaints/getAuditLogs?id='+id,
    method: 'get'
  })
}

export function getStat() {
  return request({
    url: '/complaints/getstat',
    method: 'get'
  })
}

